import BasicMenu from '../../pages/Workbench/components/BasicMenu';

// A single reference row. Mirrors LinkItem: the name on the left, a 3-dot menu
// (edit / delete) on the right. Clicking the row opens the view modal (handled
// by the parent via onView) — it does not navigate to the URL/DOI.
const ReferenceItem = ({
  reference,
  onView,
  onCopy,
  deleteHandler,
  editHandler,
  canEdit = true,
}) => {
  return (
    <div className="link-item" onClick={onView} style={{ cursor: 'pointer' }}>
      <div className="link-header">
        <p
          style={{
            marginBottom: 0,
            marginTop: 1,
            padding: 0,
            fontSize: '16px',
            color: 'black',
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textAlign: 'left',
          }}
        >
          {reference}
        </p>
        {canEdit && (
          <div onClick={(e) => e.stopPropagation()}>
            <BasicMenu
              deleteHandler={deleteHandler}
              editHandler={editHandler}
              copyToVerticalHandler={onCopy}
              copyToVerticalLabel="Copy Reference to Other Vertical"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferenceItem;
